import { useState } from 'react';
import './signiteToggleSwitch.scss';
const SigniteToggle = (props) => {
  return (
    <>
      <div className="toggle-switch small-switch">
        <input
          type="checkbox"
          className="toggle-switch-checkbox "
          name={props.id}
          id={props.id}
          {...props.fieldInput}
          checked={props.fieldInput.value ? true : false}
        />
        <label className="toggle-switch-label" htmlFor={props.id}>
          <span className="toggle-switch-inner" data-yes={'YES'} data-no={'NO'}></span>
          <span className="toggle-switch-switch"></span>
        </label>
      </div>
      <label className="toggleValue">{props.fieldInput.value ? 'YES' : 'NO'}</label>
    </>
  );
};

export default SigniteToggle;
